// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2seYK","justifyEnd":"Footer_justifyEnd__ZKgHO","btns":"Footer_btns__3UOUu","noEditingCopy":"Footer_noEditingCopy__uV2Rk"};